module.exports = __webpack_public_path__ + "img/cart.78cdc90c.svg";